import axios from 'axios';
import API from '../api';
import { Message } from 'view-design';
import Plugins from '@/plugins';
import { getLocal } from '@/utils/func';
const env = window.VUE_APP_ENV || process.env.VUE_APP_ENV;
/**
 * 公共请求方法
 * @param {Object} options 请求配置
 * @param {string} options.url - 请求地址
 * @param {string} [options.method] - 请求方式
 * @param {Object} [options.params] - 请求参数(get)
 * @param {Object} [options.data] - 请求参数(post)
 * @param {string} [options.serverName] - 服务名
 * @param {Object} [exOptions] - 额外配置
 * @param {boolean} [exOptions.useGlobalLoading] - 是否启用全局loading
 * @param {boolean} [exOptions.closeErrorMessage] - 是否关闭错误提示
 * @param {boolean} [exOptions.showSuccessMessage] - 是否开启成功提示
 * @param {boolean} [exOptions.resolveError] - 是否在报错后仍然通过执行
 * @param {Object} [exOptions.headers] - 额外的请求头
 */
function httpRequest(options, exOptions = {}) {
    if (env === 'noRequest')
        return Promise.reject(new Error('当前为无请求模式~')).catch(
            (error) => error
        );
    const httpInstance = axios.create({
        baseURL: API.server + options.serverName,
        headers: {
            PlatformId: 'SF',
            applicationCode: '1000',
        },
    });

    httpInstance.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem('token');
            const { userCode } = getLocal('userInfo', true, {});
            config.headers = {
                ...config.headers,
                userCode,
                createUserCode: userCode,
            };
            if (!!token) {
                config.headers['Authorization'] = token || '';
            }
            if (exOptions.headers) {
                config.headers = { ...config.headers, ...exOptions.headers };
            }
            return config;
        },
        (error) => {
            throw error;
        }
    );
    httpInstance.interceptors.response.use(
        (response) => {
            const data = response.data || {};
            if (options.notReg) return Promise.resolve(data);

            if (data.success) {
                if (exOptions.showSuccessMessage) {
                    Message.success(data.message);
                }
                return Promise.resolve(data);
            }
            if (!exOptions.closeErrorMessage) {
                Message.error(
                    data.message
                        ? data.message
                        : data.code === 'SF00'
                        ? '连接超时'
                        : '服务异常'
                );
            }
            // token过期
            if (data.code === 'TK03' && window.$vueInstance) {
                window.$vueInstance.$store.dispatch('comon/exit');
            }
            if (exOptions.resolveError) {
                return Promise.resolve(data);
            }

            return Promise.reject(data.message);
        },
        (error) => {
            if (!exOptions.closeErrorMessage) {
                Message.error(error || '服务异常');
            }
            return Promise.reject(error || '网络异常');
        }
    );
    return httpInstance.request({
        ...options,
        method: options.method || 'post',
    });
}

export default httpRequest;
